/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, February 2022
 * @format
 * @flow
 */

import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import FBCheckDetails from '../../../Fireboard/components/Body/CheckDetails';

const CheckDetails = props => {
  const {
    selectedCheck,
    currency,
    iso2,
    showPopup,
    onRequestRefreshGuestGPS,
    showMemberDetailPopup,
    items,
    pendingItems,
    onPrintPress,
    onClickSms,
    openCaptureSeatNamePopup,
    enableAgeRestrictedOrderingForSeat,
    onUpdateAgeRestrictedItemsForSeat,
    sendPendingItems,
    enableAgeVerification,
    enableAgeRestrictedOrderingForCheck,
  } = props;

  const { data: storeInfo } = useSelector(state => state.storeInfo);
  const { enableGpsLocation, latitude, longitude, serverAppFeatures } = storeInfo || {};
  const { supportsTipsOnTotalAmount = false, suppressTipsOnFireBoard = false } = serverAppFeatures || {};

  return (
    <FBCheckDetails
      selectedItem={selectedCheck}
      items={items}
      supportsTipsOnTotalAmount={supportsTipsOnTotalAmount}
      showMemberDetailPopup={showMemberDetailPopup}
      onPrintPress={onPrintPress}
      getManagerNotifications={[]}
      pendingItems={pendingItems}
      // showApprovalReasonsPopup={showApprovalReasonsPopup}
      currency={currency}
      iso2={iso2}
      suppressTipsOnFireBoard={suppressTipsOnFireBoard}
      // acknowledgeIdCheck={acknowledgeIdCheck}
      enableGpsLocation={enableGpsLocation}
      latitude={latitude}
      longitude={longitude}
      viewGuestLocationOnMap={() => showPopup('viewOnMap')}
      onRequestRefreshGuestGPS={onRequestRefreshGuestGPS}
      onClickSms={onClickSms}
      openCaptureSeatNamePopup={openCaptureSeatNamePopup}
      enableAgeRestrictedOrderingForSeat={enableAgeRestrictedOrderingForSeat}
      onUpdateAgeRestrictedItemsForSeat={onUpdateAgeRestrictedItemsForSeat}
      orderPendingItems={pendingItems}
      sendPendingItems={sendPendingItems}
      enableAgeVerification={enableAgeVerification}
      enableAgeRestrictedOrderingForCheck={enableAgeRestrictedOrderingForCheck}
    />
  );
};

export default CheckDetails;

CheckDetails.propTypes = {
  selectedCheck: PropTypes.object,
  currency: PropTypes.string,
  iso2: PropTypes.string,
  showPopup: PropTypes.func,
  onRequestRefreshGuestGPS: PropTypes.func,
  showMemberDetailPopup: PropTypes.func,
  items: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  pendingItems: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onPrintPress: PropTypes.func,
  onClickSms: PropTypes.func,
  openCaptureSeatNamePopup: PropTypes.func,
  enableAgeRestrictedOrderingForSeat: PropTypes.bool,
  onUpdateAgeRestrictedItemsForSeat: PropTypes.func,
  sendPendingItems: PropTypes.func,
  enableAgeVerification: PropTypes.bool,
  enableAgeRestrictedOrderingForCheck: PropTypes.bool,
};

CheckDetails.defaultProps = {
  selectedCheck: {},
  currency: '$',
  iso2: 'us',
  showPopup: () => { },
  onRequestRefreshGuestGPS: () => { },
  showMemberDetailPopup: () => { },
  items: [],
  pendingItems: [],
  onPrintPress: () => { },
  onClickSms: () => { },
  openCaptureSeatNamePopup: () => { },
  enableAgeRestrictedOrderingForSeat: false,
  onUpdateAgeRestrictedItemsForSeat: () => { },
  sendPendingItems: () => { },
  enableAgeVerification: false,
  enableAgeRestrictedOrderingForCheck: false,
};
